import { axios_requer } from "../axios/http_axios";

// 参数有这些,需要的就填,不写就用默认值

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名

let hasSing = true; //需要签名的加上这个
let method = "GET"; //需要GET请求的加上这个
let headerType = "json"; //需要JSON格式的加上这个

export default {
  // 校验任务是否包含冲突品类
  async checkTaskHasClashItem(params) {
    return await axios_requer({
      path: "/admin/v3/tms/task/checkTaskHasClashItem",
      params,
      headerType,
    }).then((res) => res);
  },
  // 确认配载
  async createDispatch(params) {
    return await axios_requer({
      path: "/admin/v3/tms/dispatch/createDispatch",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 批次任务排序导入预览
  async importDispatchTaskSortV3(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importDispatchTaskSortV3",
      params,
      headerType,
    }).then((res) => res);
  },
  // 导入批次任务排序数据校验
  async importDispatchTaskSortCheckV3(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importDispatchTaskSortCheckV3",
      params,
      hasSing,
      headerType,
    }).then((res) => res);
  },
  // 确认导入批次任务排序数据
  async importDispatchTaskSortSureV3(params) {
    return await axios_requer({
      path: "/v3/admin/poi/importDispatchTaskSortSureV3",
      params,
      hasSing,
      headerType
    }).then((res) => res);
  },
};
